<div class="relative flex items-center justify-center gap-1 rounded p-[2px] text-white">
  <div
    [ngClass]="{
      'bg-[#333333]': selectedOption.sortBy === 'createdAt',
      'bg-gray-300': selectedOption.sortBy !== 'createdAt',
    }"
    (click)="selectOption('createdAt')"
    class="w-24 min-w-fit cursor-pointer rounded px-2 py-1 text-center text-xs transition-all duration-300 sm:w-32"
    data-cy="sort-latest"
  >
    <span>Latest</span>
  </div>

  <div
    [ngClass]="{
      'bg-[#333333]': selectedOption.sortBy === 'voteCount',
      'bg-gray-300': selectedOption.sortBy !== 'voteCount',
    }"
    (click)="selectOption('voteCount')"
    class="w-24 min-w-fit cursor-pointer rounded px-2 py-1 text-center text-xs transition-all duration-300 sm:w-32"
    data-cy="sort-most-popular"
  >
    <span>Most Popular</span>
  </div>

  <div
    [ngClass]="{
      'bg-[#333333]': selectedOption.sortBy === 'mostComments',
      'bg-gray-300': selectedOption.sortBy !== 'mostComments',
    }"
    (click)="selectOption('mostComments')"
    class="w-24 min-w-fit cursor-pointer rounded px-2 py-1 text-center text-xs transition-all duration-300 sm:w-32"
    data-cy="sort-most-comments"
  >
    <span>Most Comments</span>
  </div>
</div>
